import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes";

export const getRevenueReports = async () => {
    const response = await apiService.get(apiRoutes.adminRevenueReports);
    return response.data;
};

export const getReportDetail = async (period) => {
    const response = await apiService.get(apiRoutes.adminReportDetail + `?period=${period}`);
    return response.data;
};

export const getReports = async (type) => {
    const response = await apiService.get(apiRoutes.adminReports + `?type=${type}`);
    return response?.data || [];
};

export const sendMail = async (data) => {
    const response = await apiService.post(apiRoutes.adminSendMail, data);
    return response.data;
};

export const reportDetail = async (reportId) => {
    const response = await apiService.post(apiRoutes.adminReportDetail,reportId);
    return response.data;
};

export const markResolve = async (reportId) => {
    const response = await apiService.post(apiRoutes.adminMarkResolve,reportId);
    return response.data;
};